import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../config';

const requestSchema = z.object({
	EncryptedPolicyId: z.string(),
	DocumentNumber: z.string(),
	Type: z.string(),
	File: z.string(),
});

export const responseSchema = z.object({
	fileUrl: z.string(),
	lastUpdatedOn: z.string(),
});

const postPolicyUploadInvoice = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: 'admin/policy/document/upload',
		headers: {
			'Content-Type': 'multipart/form-data',
		},
		errorCodes: [
			'InvoiceNumberIsAlreadyUsedForIC', // invoice number exist
			'InvoiceNumberError', // validation for length of 50
		],
		method: 'POST',
		responseSchema,
		requestSchema,
	});

export type postPolicyUploadInvoiceRequest = z.infer<typeof requestSchema>;

export type postPolicyUploadInvoiceResponse = TypeOfAPIResponse<ReturnType<typeof postPolicyUploadInvoice>>;

export type postPolicyUploadInvoiceError = TypeOfAPIError<ReturnType<typeof postPolicyUploadInvoice>>;

export default postPolicyUploadInvoice;
